export const LAYOUT_PRESETS = {
    standard: { label: 'Standard', infoRatio: 0.33 },
    scriptPriority: { label: 'Script priority', infoRatio: 0.15 },
    interview: { label: 'Interview', infoRatio: 0.4 },
    split: { label: 'Split', infoRatio: 0.5 },
    scriptOnly: { label: 'Script only', infoRatio: 0 },
    alertTakeover: { label: 'Alert takeover', infoRatio: 0.75 },
};
export const DEFAULT_LAYOUT = {
    presetId: 'standard',
    infoRatio: LAYOUT_PRESETS.standard.infoRatio,
};
export function layoutFromPreset(presetId) {
    return { presetId, infoRatio: LAYOUT_PRESETS[presetId].infoRatio };
}
//# sourceMappingURL=layout.js.map